// extracted by mini-css-extract-plugin
export default {"main-page":"style-scoped__main-page--nyfTj","mainPage":"style-scoped__main-page--nyfTj","container":"style-scoped__container--ogwYM"};